module.exports = __webpack_public_path__ + "img/curacao.98e781af.png";